<template>
  <div class="appcontainer">
    <div class="container">
      <div class="filter">
        <div class="filter-select">
          <div class="filter-title">品牌：</div>
          <div class="select-width">
            <el-select v-model="listQuery.brand" @change="changeBrandStatus" filterable placeholder="全部" size="mini"
              style="width:100%">
              <el-option v-for="(item, index) in listp" :key="index" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-select">
          <div class="filter-title">状态：</div>
          <div class="select-width">
            <el-select v-model="listQuery.state" @change="changeActivityStatus" filterable placeholder="全部" size="mini"
              style="width:100%">
              <el-option v-for="(item, index) in liststatus" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-select">
          <div class="filter-title">类型：</div>
          <div class="select-width">
            <el-select v-model="listQuery.createBy" @change="switchType" filterable placeholder="全部" size="mini" style="width:100%">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="pagecontent">
        <el-table :data="tableData" style="width: 100%" stripe v-loading="listLoading">
          <el-table-column width="120" align="center" type="index" label="App瓷片排序">
            <!--   <template slot-scope="scope">
              <div>
                {{index}}
              </div>
            </template> -->
          </el-table-column>
          <!-- <el-table-column prop="porcelain" label="app瓷片排序" width="150" align="left"></el-table-column> -->
          <el-table-column prop="mainTitle" label="主题" align="left">
            <template slot-scope="scope">
              <div>
                {{scope.row.mainTitle ? scope.row.mainTitle : '暂无主题'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="subtitle" label="副标题" align="left">
            <template slot-scope="scope">
              <div>
                {{scope.row.subtitle ? scope.row.subtitle : '暂无副标题'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="瓷片预览" align="left" style="cursor:pointer">
            <template slot-scope="scope">
              <div v-if="scope.row.urlName" style="height: 80px;">
                <div style="height: 30%;width: 50px;" :style="{ backgroundImage: 'linear-gradient(' + scope.row.color + ',' + 'rgba(255, 255, 255, 1)' }"></div>
                <img v-lazy="scope.row.urlName" alt style="cursor: pointer;width: 50px; height: 50px;" @click="showDialog(scope.row.urlName)" />
              </div>
              <div v-else>暂无图片</div>
              <!-- 此处图片再这里出现bug 显示在蒙版中，层级降低 z-index.所以拿出来放在外面解决此bug -->
              <!-- <el-dialog :visible.sync="dialogVisible">
                <div>sfladlfjaldsj</div>
                <img style="width: 100%; height: 100%" :src="scope.row.url" alt="ll" />
              </el-dialog>-->
            </template>
          </el-table-column>
          <el-table-column prop="color" label="颜色值" align="left">
            <template slot-scope="scope">
              <div> {{scope.row.color}} </div>
            </template>
          </el-table-column>

          <el-table-column prop="brandName" label="品牌" align="left"></el-table-column>
          <el-table-column prop="type" label="类型" align="left">
            <template slot-scope="scope">
              <div>
                <el-link type="primary" :underline="false">
                  <div class="linkTip" @click="jumpNewPage(scope.row)">{{ scope.row.createBy ? scope.row.createBy : '暂无' }}</div>
                </el-link>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column show-overflow-tooltip width="300" show-overflow-tooltip prop label="活动有效时间" align="center">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div class="linkTip">-->
          <!--              <span>{{ formDateTime(scope.row.createTime) }}</span>-->
          <!--              <span>至</span>-->
          <!--              <span>{{ formDateTime(scope.row.lastUpdateTime) }}</span>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="state" label="状态" align="left">
            <template slot-scope="scope">
              <span class="green-text" v-if="scope.row.state == 1">上架</span>
              <span class="red-text" v-if="scope.row.state == 2">下架</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" width="300" label="操作" align="left">
            <template slot-scope="scope">
              <el-button @click.native.prevent="up(scope.row)" type="text" size="small" :disabled="scope.row.state == 1">
                <span :class="scope.row.state == 1 ? 'gray-text' : 'blue-text'">上架</span>
              </el-button>
              <el-button @click.native.prevent="down(scope.row)" type="text" size="small" :disabled="scope.row.state == 2">
                <span :class="scope.row.state == 2 ? 'gray-text' : 'blue-text'">下架</span>
              </el-button>
              <div class="fromrelative">
                <el-button @click.native.prevent="showRow(scope.row)" type="text" size="small" :disabled="scope.row.state == 1">
                  <span :class="scope.row.state == 1 ? 'gray-text' : 'blue-text'">更多</span>
                </el-button>
                <div class="formabsolive" v-if="scope.row.ismore">
                  <div class="fb" @click="updateRow(scope.row)">修改</div>
                  <div class="fb" @click="lookRow(scope.row)">查看</div>
                  <!-- <div class="fb" @click="delRow(scope.row)">删除</div> -->
                </div>
              </div>
              <el-button @click.native.prevent="tomove(scope.$index, true, scope.row)" type="text" size="small"><span
                  class="blue-text">上移</span></el-button>
              <el-button @click.native.prevent="tomove(scope.$index, false, scope.row, 1)" type="text" size="small"><span
                  class="blue-text">下移</span></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tablepage.pageindex"
          :page-size="tablepage.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tablepage.total"
        ></el-pagination>-->
      </div>
    </div>

    <el-dialog title="新建活动" :visible.sync="newDialogVisible" width="50%" :before-close="handleClose">
      <div class="container_dialog">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="活动主题">
            <el-input v-model="form.name" placeholder="请输入活动主题"></el-input>
          </el-form-item>
          <el-form-item label="活动时间">
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col class :span="1">至</el-col>
            <el-col :span="11">
              <el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 100%;"></el-time-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="选择模版">
            <div class="solid"></div>
            <el-col :span="8" v-for="(item, index) in temList" :key="index">
              <div class="templates" @click="selectItem(index)">
                <div class="templates_item"></div>
                <div><i :class="activeIndex == index ? 'select_icon el-icon-success' : 'el-icon-success'"></i></div>
              </div>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class>
        <el-button @click="prevClick">上一页</el-button>
        <span>2/3</span>
        <el-button @click="nextClick">下一页</el-button>
        <el-button type="primary" @click="newDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="newDialogVisible = false">生成</el-button>
        <el-button type="primary" @click="newDialogVisible = false">保存</el-button>
      </span>
    </el-dialog>

    <!-- 修改瓷片区 -->
    <el-dialog title="修改瓷片" :visible.sync="newDialogVisibles" width="25%" :before-close="handleClose" center>
      <div class="container_dialog">
        <el-form ref="form" :model="form" label-width="80px" :disabled="formDisabled">
          <el-form-item label="主标题">
            <el-input v-model="form.mainTitle" placeholder="请输入主标题" maxlength="5" show-word-limit size="small"></el-input>
          </el-form-item>
          <el-form-item label="副标题">
            <el-input v-model="form.subtitle" placeholder="请输入副标题" maxlength="5" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="瓷片区图片" label-width="90px">
            <!-- <div class="flex_row">
              <el-upload
                class="avatar-uploader"
                ref="uploadimg"
                :action="img_url"
                accept="image/png, image/jpeg"
                :show-file-list="true"
                size="mini"
                list-type="picture-card"
                :auto-upload="true"
                :on-change="onoverviewPictures1"
                :on-preview="handlePictureCardPreview1"
                :on-remove="handleRemove"
                :file-list="dialogImageUrlArray1"
                :on-success="handleAvatarSuccess1"
                :before-upload="beforeAvatarUpload"
                :on-exceed="onExceed"
                :data="imgdata"
                :limit="1"
              >
                <img v-if="form.url" :src="form.url" class="el-upload-list__item-thumbnail"  />
                <i v-if="!form.url" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div>
                <el-dialog :visible.sync="dialogVisible1" :modal="false">
                  <img width="100%" :src="form.url" alt />
                </el-dialog>
              </div>
              瓷片尺寸大小为:169*130
            </div>-->
            <div class="select_template" @click="choseimg">
              <div v-if="form.urlName" class="img_template"><img v-lazy="form.urlName" alt /></div>
              <div class="mask_template" v-else>
                <div class="icon el-icon-circle-plus-outline"></div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="瓷片背景">
            <el-color-picker @change="changebg" v-model="form.color" show-alpha :predefine="predefineColors"></el-color-picker>
          </el-form-item>
          <el-form-item label="所属品牌">
            <el-select :disabled="true" v-model="form.brand" @change="changeBrand" filterable placeholder="全部" size="mini"
              style="width:100%">
              <el-option v-for="(item, index) in listp" :key="index" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="选择类别">
            <el-radio-group size="small" v-model="form.type">
              <el-radio label="供应商"></el-radio>
              <el-radio label="外部链接"></el-radio>
              <el-radio label="营销活动"></el-radio>
              <el-radio label="商品"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="form.type">
            <el-input v-model="form.id" placeholder="请输入"></el-input>
          </el-form-item>-->
          <el-form-item>
            <el-button @click="newDialogVisibles = false">取 消</el-button>
            <el-button :loading="subLoading" type="primary" @click="saveActivity">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" center>
      <img style="width: 100%; height: 100%" :src="dialogImgUrl" alt="图片已被删除" />
      <div></div>
    </el-dialog>

    <el-dialog title="选择图片" :visible.sync="imglistDialogVisible" width="38%" :before-close="handleClose">
      <div class="container_dialog">
        <div class="shaixuan">
          <div class="name">筛选图片:</div>
          <el-input size="mini" v-model="searchName" placeholder="请输入图片名称"></el-input>
          <el-button @click="search" style="margin-left: 10px" type="primary" size="mini">搜索</el-button>
        </div>
        <div class="cholse_imglsit">
          <div class="list" v-if="imglists.length > 0">
            <div class="imgbox" v-for="(item, index) in imglists" @click="changeimg(item)" :key="index">
              <div v-loading="item.switchImg" element-loading-spinner="el-icon-check" element-loading-background="rgba(0, 0, 0, 0.5)"
                class="img">
                <img v-lazy="item.link" alt srcset />
              </div>
              <div class="title">{{ item.name }}</div>
            </div>
          </div>
          <div class="lists" v-else><span>请上传图片库</span></div>
        </div>
      </div>
      <span slot="footer" class>
        <el-button type="primary" @click="imglistDialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import stringify from 'qs/lib/stringify';
  import {
    getapppage, // 获取品牌
    apppagelist, // 获取列表
    apppagestate, // 上架下架更改状态
    apppagedetails, // 根据id 获取详情数据
    putapppage, // 修改app活动接口
    apppagedel, // 删除活动
    apppagesort, // 上移下移
    appageRemoveImg // 删除
  } from '@/api/activesapis';

  import {
    getpicture,
    updateActive
  } from '@/api/activesapi';
  import {
    parseTime
  } from '@/utils';

  export default {
    data() {
      return {
        bgColor: '', //表单显示渐变背景色
        subLoading: false,
        predefineColors: [
          '#ff4500',
          '#ff8c00',
          '#ffd700',
          '#90ee90',
          '#00ced1',
          '#1e90ff',
          '#c71585',
          'rgba(255, 69, 0, 0.68)',
          'rgb(255, 120, 0)',
          'hsv(51, 100, 98)',
          'hsva(120, 40, 94, 0.5)',
          'hsl(181, 100%, 37%)',
          'hsla(209, 100%, 56%, 0.73)',
          '#c7158577'
        ],
        searchName: '',
        img_url: '/v1/file/upload/file',
        listLoading: false, // 表格加载
        dialogVisible: false, // 缩略图
        dialogImgUrl: '', // 弹窗图片
        editDialogImgUrl: '', // 编辑弹窗的图片
        newDialogVisible: false, // 新建活动
        newDialogVisibles: false, // 修改瓷片去
        imgdata: {
          file: ''
        },
        formDisabled: false, // 表单禁用

        dialogImageUrlArray1: [],
        // form: {
        //   url: '', // 图片地址
        //   dialogVisible1: false, // 展示
        // },
        dialogVisible1: false,
        activeIndex: 0,
        form: {
          brand: '',
          createBy: '',
          delFlag: '',
          lastUpdateBy: '',
          link: '',
          mainTitle: '',
          porcelain: '',
          sort: '',
          standby5: '',
          subtitle: '',
          type: '供应商',
          src: '',
          url: '',
          color: ''
        },
        listp: {},
        // 请求参数
        listQuery: {
          brand: 'VHG',
          pageSize: 10,
          pageNum: 1,
          state: 0,
          createBy: 0
        },

        // 状态
        liststatus: [{
          label: '全部',
          value: 0
        }, {
          label: '通过',
          value: 1
        }, {
          label: '拒绝',
          value: 2
        }],
        // 类型
        typeList: [{
            label: '全部',
            value: 0
          },
          {
            label: '供应商',
            value: 1
          },
          {
            label: '外部链接',
            value: 2
          },
          {
            label: '营销活动',
            value: 3
          },
          {
            label: '商品',
            value: 4
          },
          {
            label: '商品分类',
            value: 5
          }
        ],
        tablepage: {
          // pageindex:1,
          // total:10,
          // size:20,
        },
        //   图片列表
        imglists: [],
        imglistDialogVisible: false, // 选择图片
        //   筛选图片
        imgpic: {
          name: '',
          state: 0,
          type: 0
        },
        //visible
        visible: false,
        tableData: [], // 表哥数组
        temList: [{
          label: '模版'
        }, {}, {}], // 模版数组

        // 列表参数
        paramsList: {}
      };
    },
    watch: {},
    // computed: {
    //   roles() {
    //     return this.role.admin == this.userinfo.role;
    //   },
    // },
    async created() {
      this.initdata();
      console.log('lkkk', this.getUrlParam('name', 'https://www.baidu.com/?id=2&name=lxs'));
    },
    methods: {
      switchType(val) {
        console.log(val)
        this.listQuery.createBy = val;
        this.initdata();
      },
      changebg(e) {},
      jumpNewPage(val) {
        console.log(val);
        this.$router.push({
          path: '/campaign/ImageManagement',
          query: {
            id: val.url
          }
        });
      },
      search() {
        this.getdataimg();
      },
      choseimg(i) {
        this.imglistDialogVisible = true;
        this.getdataimg();
      },
      changeimg(item) {
        this.imglists.forEach(ele => (ele.switchImg = false));
        item.switchImg = true;
        this.form.urlName = item.link;
        this.form.url = item.id;
        this.$forceUpdate();
      },
      // 选择图片
      getdataimg() {
        let params = {
          name: this.searchName,
          state: 0,
          row: 0,
          type: 1
        };
        getpicture(params).then(res => {
          console.log('图片数据', res.data.data);
          if (res.status == 200 && res.data.code == 0) {
            this.imglists = res.data.data;
          }
        });
      },
      /**
       * 接口请求
       */
      initdata() {
        this.getpinpai();
        this.getapppageList(this.listQuery);
      },
      // 获取 品牌
      async getpinpai() {
        let a = await getapppage();
        let data = this.fromval(a);
        if (data) {
          this.listp = data;
        }
        console.log('品牌', this.listp);
      },
      // 获取列表
      async getapppageList(val) {
        console.log('请求列表需要的参数：', val);
        let a = await apppagelist(val);
        this.listLoading = true;

        if (a.status == 200) {
          this.listLoading = false;
          if (a.data) {
            let resdata = [];
            resdata = a.data.list;
            // this.tableData = a.data.list
            // 添加ismore:false
            // 根据sort字段升序排序
            resdata.sort(function(a, b) {
              return +a.sort - +b.sort;
            });
            resdata.forEach((el, index) => {
              el.ismore = false;
            });
            this.tableData = resdata;
            console.log('初始化列表数据', this.tableData);
            // 总条数
            this.tablepage.total = a.data.total;
            // 每页多少条
            this.tablepage.size = a.data.pageSize;
          }
        }
        let data = this.fromval(a);
        // if(data){
        //    this.listp.list = data
        // }
        // console.log('ll', a)
        // console.log('获取列表', data)
      },
      // 格式化数据
      fromval(val) {
        if (val.data && val.data.code == 0) {
          return val.data.data;
        } else {
          return false;
        }
      },
      /**
       * 列表操作
       */
      showRow(e) {
        console.log(e);

        this.tableData.map(item => {
          if (item.id == e.id) {
            item.ismore = !item.ismore;
          } else {
            item.ismore = false;
          }
          return item;
        });
        this.$forceUpdate();
      },
      // 下架
      down(e) {
        console.log(e);

        let params = {
          id: e.id,
          state: 2
        };
        this.$confirm('是否下架?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'none',
            center: true
          })
          .then(() => {
            this.upAnddown(params);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消下架'
            });
          });
      },
      // 上架
      up(e) {
        console.log(e);
        // async getapppage(val)
        let params = {
          id: e.id,
          state: 1
        };

        this.$confirm('是否上架?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'none',
            center: true
          })
          .then(() => {
            this.upAnddown(params);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消上架'
            });
          });
      },
      // 上架或下架的请求
      async upAnddown(params) {
        // {id}/{state}(1上架 2下架)
        let resultdata = await apppagestate(params);
        this.initdata();
      },
      // 根据id获取详情
      async getDetail(params) {
        let result = await apppagedetails(params);
        let data = this.fromval(result);
        console.log('根据id 获取详情', data);
        this.form = data;
      },
      // 排序接口
      async sortData(arr) {
        let result = await apppagesort(arr);
        let data = this.fromval(result);
        if (data) {
          this.$message({
            type: 'success',
            message: '成功'
          });
          this.initdata();
        }
      },
      tomove(index, e, val) {
        // console.log(val, index, e)
        console.log('下标：', index, '当前元素：', val, '上移动？', e);

        if (e) {
          this.moveuptools(index, val);
        } else {
          this.movedowntools(index, val);
        }
      },
      moveuptools(i, el) {
        let temp = null;
        let arr = JSON.parse(JSON.stringify(this.tableData));
        console.log('arr[i]', +arr[i].sort, el.sort);
        // return

        if (i >= 1) {
          // 1    2    3
          // temp = arr[i]
          // arr[i] = arr[i - 1]
          // arr[i - 1] = temp
          // this.tableData = arr
          // 需要的两条数据 arr[i] arr[i-1]

          this.$confirm('是否上移?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              let currentElUPSort = +arr[i].sort - 1;
              let currentElDownSort = +arr[i - 1].sort + 1;
              console.log('curren:', currentElUPSort, currentElDownSort);

              // console.log('上移动的参数',arrList)

              // let params = {
              //   list: [
              //     { id: el.id, sort: currentElUPSort },
              //     { id: arr[i].id, sort: currentElDownSort },
              //   ],
              // }

              let listPrams = [{
                id: arr[i].id,
                sort: currentElUPSort
              }, {
                id: arr[i - 1].id,
                sort: currentElDownSort
              }];
              let params = {
                list: JSON.stringify(listPrams)
              };
              // 请求数据
              this.sortData(params);
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
        } else {
          console.log('不能上移动');
          this.$notify({
            title: '警告',
            message: '到顶了不能向上移动了',
            type: 'warning'
          });
        }
      },
      movedowntools(i, el) {
        let temp = null;
        let arr = JSON.parse(JSON.stringify(this.tableData));
        console.log('arr[i】', +arr[i].sort, el.sort);

        if (i <= arr.length - 2) {
          // 1    2    3
          // temp = arr[i]
          // arr[i] = arr[i + 1]
          // arr[i + 1] = temp
          // this.tableData = arr
          console.log('current index:', i);
          this.$confirm('是否下移?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              // arr[i] 是上一个元素
              let currentElUPSort = +arr[i].sort + 1;
              let currentElDownSort = +arr[i + 1].sort - 1;
              console.log('curren or next:', currentElUPSort, currentElDownSort);

              // console.log('上移动的参数',arrList)
              // let params = {
              //   list: [
              //     { id: el.id, sort: currentElUPSort },
              //     { id: arr[i + 2].id, sort: currentElDownSort },
              //   ],
              // }

              let listPrams = [{
                id: arr[i].id,
                sort: currentElUPSort
              }, {
                id: arr[i + 1].id,
                sort: currentElDownSort
              }];

              let params = {
                list: JSON.stringify(listPrams)
              };
              // 请求数据
              this.sortData(params);
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
        } else {
          console.log('不能下移动');
          this.$notify({
            title: '警告',
            message: '到底了不能向下移动了',
            type: 'warning'
          });
        }
      },
      /**
       * 修改 活动
       */
      updateRow(e) {
        this.newDialogVisibles = true;
        this.formDisabled = false;
        let params = {
          id: e.id
        };
        this.getDetail(params);
      },
      lookRow(e) {
        this.newDialogVisibles = true;
        this.formDisabled = true;
        let params = {
          id: e.id
        };
        this.getDetail(params);
      },

      delRow(e) {
        console.log(e);
        let params = {
          ids: e.id
        };
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            apppagedel(params).then(res => {
              console.log('res:', res);
              if (res.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
                // this.getapppageList()
                this.initdata();
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      //
      // 上传改变状态  首焦图
      onoverviewPictures1(file, fileList) {
        let fileLists = this.beforeupdateimg(file, fileList);
        this.dialogImageUrlArray1 = fileLists;
      },
      // 点击已上传的文件链接时的钩子
      handlePictureCardPreview1(file) {
        console.log('点击已上传', file);
        this.form.url = file.url;
        this.dialogVisible1 = true;
      },
      beforeupdateimg(file, fileList) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'; // 图片类型
        const isLt2M = file.size / 1024 / 1024 < 5; // 图片大小
        if (isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
          fileList.pop();
        }
        let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
          fileList.pop();
        }
        if (existFile) {
          this.$message.error('当前文件已经存在!');
          fileList.pop();
        }
        console.log('上传文件', fileList);
        return fileList;
      },
      // 文件个数限制
      onExceed(files, fileList) {
        console.log('文件个数限制', files, fileList);
        this.$message({
          type: 'info',
          message: '只能上传一张图片！如需上传新的图片，请移除当前图片',
          duration: 3000
        });
      },
      // 上传文件之前的钩子
      beforeAvatarUpload(file) {
        console.log('图片正在上传', file);
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'; // 图片类型
        const isLt2M = file.size / 1024 / 1024 < 2; // 图片大小
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;

        /**
         * 此处限制格式为 169*130 已经做好，无需在判断图片类型
         * ！！！ 此注释不要删掉
         */
        // let that = this
        // const is1M = file.size / 1024 / 1024 < 1

        // const isSize = new Promise((resolve, reject) => {
        //   let width = 169
        //   let height = 130
        //   let _URL = window.URL || window.webkitURL
        //   let img = new Image()
        //   img.onload(() => {
        //     let isComplate = img.width == width && img.height == height
        //     isComplate ? resolve() : reject()
        //   })
        //   img.src = _URL.createObjectURL(file)
        // }).then(
        //   () => {
        //     return file
        //   },
        //   () => {
        //     that.$message.error('上传图片限制为169 x 130，大小不可超过1MB')
        //   }
        // )
        // if (!is1M) {
        //   that.$message.error('上传图片限制为169 x 130，大小不可超过1MB')
        // }
        // return isSize && is1M
      },
      // 证件照上传成功时的钩子
      handleAvatarSuccess1(res, file, h) {
        console.log('证件照上传成功', res, h);
        console.log('测试', file);

        if (res.code == 0) {
          this.form.url = res.data;
        }
        // if (res.errorCode == 0) {
        //   this.form.url = res.result
        // }
        // this.imageUrlIdPhone = URL.createObjectURL(file.raw);
      },
      // 移除图片
      handleRemove(file, fileList) {
        console.log('移除图片', file, fileList);
        // console.log(file, fileList);
        // this.form.url = ''
        // this.getvandordetail(this.rowdata.id)
        let key = {
          key: this.form.url
        };
        // this.removeImage(key)
        appageRemoveImg(key)
          .then(res => {
            console.log('remove img res:', res);

            if (res.data.code == 0) {
              this.form.url = '';
            }
          })
          .catch(err => {
            console.log(err);
          });

        console.log('this.form:', this.form);
      },
      /**
       * 改变品牌状态
       */
      changeBrandStatus(e) {
        console.log(e);
        this.listQuery.brand = e;
        // this.getapppageList(this.listQuery)
        this.initdata();
        this.$forceUpdate();
      },
      // 改变活动状态
      changeActivityStatus(e) {
        console.log('改变活动状态', e);
        this.listQuery.state = e;
        // this.getapppageList(this.listQuery)
        this.initdata();
      },
      // dialog 改变品牌
      changeBrand(e) {
        console.log(e);
      },
      addCampaign() {
        this.newDialogVisible = !this.newDialogVisible;
      },
      // 表格关闭
      handleClose() {
        this.newDialogVisible = false;
        this.newDialogVisibles = false;
        this.imglistDialogVisible = false;
      },
      // 表格分页
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);

        this.initdata();
      },

      prevClick() {},
      nextClick() {},
      //
      selectItem(index) {
        this.activeIndex = index;
      },
      // 保存
      saveActivity() {
        console.log('this.form:', this.form);
        this.saveAc();
      },
      async saveAc() {
        // let param = JSON.stringify(this.form)
        let param = this.form;
        // 不需要
        delete param.createTime;
        delete param.lastUpdateTime;
        if(!param.mainTitle){
          return this.$message.warning("请输入主标题")
        }else if(!param.urlName){
          return this.$message.warning("请选择瓷片图")
        }
        this.subLoading = true;
        let result = await putapppage(param);
        console.log(result);
        if (result.data.code == 0) {
          this.subLoading = false;
          this.newDialogVisibles = false;
          this.$message({
            message: result.data.msg,
            type: 'success'
          });
          this.initdata();
        } else {
          this.subLoading = false;
          this.newDialogVisibles = false;
          this.$message.warning(result.data.msg);
          this.initdata();
        }
      },

      // 显示dialog 图片
      showDialog(item) {
        if (item) {
          this.dialogVisible = true;
          this.dialogImgUrl = item;
        }
      },

      showEditDialog(item) {
        if (item) {
          // this.dialogVisible1 = true
          this.editDialogImgUrl = item;
        }
      },

      // 去除时间格式是分秒
      formDateTime(val) {
        if (val == null || val == undefined) return '空';
        // return  /\d{4}-d{1,2}-\d{1,2}/g.exec(val)
        return val.substr(0, 10);
      },

      getUrlParam(name, origin = null) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        let r = null;
        if (origin == null) {
          r = window.location.search.substr(1).match(reg);
        } else {
          r = origin.substr(1).match(reg);
        }
        if (r != null) return decodeURIComponent(r[2]);
        return null;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .linkTip {
    width: 300px;
    white-space: nowrap;
    /*控制单行显示*/
    overflow: hidden;
    /*超出隐藏*/
    text-overflow: ellipsis;
    /*隐藏的字符用省略号表示*/
  }

  .el-upload-list__item-thumbnail {
    width: 140px;
    height: 140px;
  }

  .el-table .cell {
    overflow: visible !important;
  }

  .appcontainer {
    padding: 14px;
    background: #f0f0f0;
    height: 100%;

    .fromrelative {
      position: relative;
      display: inline-block;
      // z-index: 99;
      // background-color: #9e9e9e;
      margin: 0 6px;

      .formabsolive {
        width: 60px;
        // height: 100px;
        z-index: 99;
        left: -12px;
        border-radius: 5px;
        display: flex;
        flex-flow: column wrap;
        position: absolute;
        background: #f0f0f0;
        text-align: center;
        color: #363636;
        padding: 5px 0;

        .fb {
          width: 28px;
          // height: 14px;
          text-align: center;
          width: 100%;
          padding: 8px 0;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
        }

        .fb:hover {
          background: rgba(245, 247, 250, 1);
          box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
          color: rgba(6, 134, 224, 1);
        }
      }

      //     .formabsolive:hover{
      //       background:rgba(245,247,250,1);
      //       box-shadow:0px 0px 4px 0px rgba(0,0,0,0.1);
      // font-family:PingFangSC-Medium,PingFang SC;
      // font-weight:500;
      // color:rgba(6,134,224,1);
      // line-height:14px;
      // text-shadow:0px 0px 4px rgba(0,0,0,0.1);
      //           }
    }
  }

  .container {
    padding: 14px;
    background: #fff;
  }

  .pagecontent {
    height: 40vh;
    height: 100%;
  }

  .filter {
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .filter-select {
      display: flex;
      align-items: center;

      .filter-title {
        font-size: 14px;
        color: #333;
        margin-right: 20px;
      }

      .select-width {
        width: 120px;
        margin-right: 20px;
      }
    }

    .filter-btn {
      display: flex;
      // align-items: center;
    }
  }

  .paging {
    // margin-top: 50px;
    margin-top: 100px;

    text-align: center;
  }

  .container_dialog {
    .templates {
      display: flex;
      flex-direction: column;
      align-items: center;

      .templates_item {
        width: 132px;
        height: 161px;
        background-color: #b7d9ed;
      }

      .select_icon {
        color: #1182fb;
      }
    }

    .select_template {
      width: 120px;
      height: 120px;
      background: rgba(243, 247, 255, 1);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;

      .mask_template {
        position: absolute;
        top: 50%;
        right: 50%;
        // opacity: 0.3;
        transform: translate(50%, -50%);
      }

      .img_template {
        img {
          height: 120px;
          width: 100%;
        }
      }

      .icon {
        font-size: 30px;
        color: #c0c4cc;
      }

      .icon:hover {
        color: #0686e0;
      }
    }

    .shaixuan {
      display: flex;
      align-items: center;
      width: 80%;

      .name {
        width: 100px;
      }

      input {
        width: 60px;
      }
    }

    .cholse_imglsit {
      width: 100%;
      height: 437px;
      overflow-y: auto;
      display: flex;
      flex-flow: column wrap;
      // justify-content: center;
      text-align: center;

      .lists {
        display: flex;
        height: 300px;
        widows: 100%;
        justify-content: center;
        align-items: center;
        text-align: center;
      }

      .list {
        display: flex;
        flex-flow: row wrap;
        // justify-content: center;
        width: 100%;

        .imgbox {
          margin: 20px;
          // width: 130px;
          height: 120px;
          background: rgba(233, 233, 233, 1);
          border: 1px solid rgba(220, 223, 230, 1);
          text-align: center;
          opacity: 1;
          border-radius: 4px;

          img {
            max-width: 230px;
            height: 120px;
          }
        }
      }

      // opacity: 1;
    }

    .templates {
      display: flex;
      flex-direction: column;
      align-items: center;

      .templates_item {
        width: 132px;
        height: 161px;
        background-color: #b7d9ed;
      }

      .select_icon {
        color: #1182fb;
      }
    }
  }

  .green-text {
    color: #1cd0bd;
    font-size: 14px;
  }

  .red-text {
    color: #ff5d5d;
    font-size: 14px;
  }

  .blue-text {
    color: #1182fb;
    font-size: 14px;
  }

  .green-text {
    color: #1cd0bd;
    font-size: 14px;
  }

  .gray-text {
    color: #b3b3b3;
    font-size: 14px;
  }
</style>
